export default __webpack_public_path__ + "static/media/depositAPY.d7e0089c.svg";